module.exports = __webpack_public_path__ + "static/img/s210.d14037a.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s210.png
// module id = 552
// module chunks = 3